// extracted by mini-css-extract-plugin
export default {"container":"Brands_container__92rbR","title":"Brands_title__m8zCb","img":"Brands_img__6dbjc","carousel__cards":"Brands_carousel__cards__SgyLU","center":"Brands_center__z8sHX"};